// Building blocks of a legal document. Arabic and English sit side by side so a clause cannot exist in
// only one language. Text is plain, with [label](href) for links: "/x" stays in the app, anything else is external.
const localized = (ar, en) => ({ ar, en });

export const section = (id, ar, en, blocks) => ({
  id,
  title: ar || en ? localized(ar, en) : null,
  blocks,
});

export const p = (ar, en) => ({ type: "paragraph", text: localized(ar, en) });

export const ul = (items) => ({
  type: "list",
  items: items.map(([ar, en]) => localized(ar, en)),
});

// A term with its explanation, e.g. a fee and what it covers: [termAr, descriptionAr, termEn, descriptionEn].
export const dl = (items) => ({
  type: "definitions",
  items: items.map(([termAr, descriptionAr, termEn, descriptionEn]) => ({
    term: localized(termAr, termEn),
    description: localized(descriptionAr, descriptionEn),
  })),
});

export const h3 = (id, ar, en) => ({ type: "subheading", id, text: localized(ar, en) });
